export const parentFAQ = [
  {
    q: 'How do I add a student?',
    a: 'Go to the Students tab and click "Add Student." Follow the step-by-step wizard to set up their grade level, interests, virtues, and word banks.',
  },
  {
    q: 'How are stories personalized?',
    a: 'Our AI generates stories based on your child\'s grade level, interests, strengths, areas for growth, cultural values, and assigned vocabulary words.',
  },
  {
    q: 'What is the Agentic Reach Score?',
    a: 'It measures how broadly your child\'s reading expands their world — covering vocabulary diversity, topic range, and comprehension depth.',
  },
  {
    q: 'How do subscriptions work?',
    a: 'You start with a free plan. Upgrade in the Subscription tab to unlock unlimited stories, advanced analytics, and premium features.',
  },
  {
    q: 'Can I turn off brand offers?',
    a: 'Yes. Go to the Offers tab and toggle "Show Offers" off. You won\'t see any promotional content from brand partners.',
  },
  {
    q: 'How do referrals work?',
    a: 'Share your referral code from the Invite & Earn tab. When someone signs up using your code, you both can earn rewards (wallet credits, discounts, etc.).',
  },
];

export const brandFAQ = [
  {
    q: 'How does brand story integration work?',
    a: 'Your brand is woven naturally into AI-generated student stories. Products appear as part of engaging narratives, not as traditional ads.',
  },
  {
    q: 'How do I create a campaign?',
    a: 'Go to the Campaigns tab, click "New Campaign," set your target audience (age, country, language), upload creatives, and set your budget.',
  },
  {
    q: 'What are Brand Offers?',
    a: 'Promotional offers pushed directly to parents/guardians. Create them in the Offers tab — they can be free trials, discounts, or external links.',
  },
  {
    q: 'How is my budget spent?',
    a: 'Your campaign budget is spent per impression. You can monitor spending in real-time on the Budget and Analytics tabs.',
  },
  {
    q: 'When will my account be approved?',
    a: 'New brand partner accounts require admin approval. You can set up your brand profile while waiting. Approval typically happens within 24-48 hours.',
  },
  {
    q: 'Can I target specific demographics?',
    a: 'Yes. Campaigns can target by age group, country, and language. Leave target fields empty to reach all markets.',
  },
];

export const studentFAQ = [
  {
    q: 'How do I get a new story?',
    a: 'Click "Create New Story" on your dashboard. The AI will generate a personalized story just for you with vocabulary words to learn.',
  },
  {
    q: 'What are vocabulary words?',
    a: 'These are highlighted words in your stories that help you learn. Answer the questions about them to add them to your Vocabulary Mastered count.',
  },
  {
    q: 'How do I join a classroom session?',
    a: 'Ask your teacher for the 6-digit session code. Enter it in the "Join Classroom Session" area on your dashboard.',
  },
  {
    q: 'What does my score mean?',
    a: 'Your Agentic Reach Score shows how much your reading is growing your mind. The more you read and answer correctly, the higher it goes!',
  },
  {
    q: 'Can I re-read old stories?',
    a: 'Yes! All your stories are saved on your dashboard. Click any story card to read it again.',
  },
];

export const teacherFAQ = [
  {
    q: 'How do I create a classroom session?',
    a: 'Go to the Sessions tab and click "New Session." You\'ll get a 6-digit code to share with your students.',
  },
  {
    q: 'Can I track individual student progress?',
    a: 'Yes. The Students tab shows each student\'s vocabulary mastered, stories read, and comprehension scores.',
  },
  {
    q: 'How do I assign word banks?',
    a: 'Word banks are assigned by parents/guardians through their portal. You can view which banks are active for each student.',
  },
  {
    q: 'Can I use this with my school curriculum?',
    a: 'Absolutely. The word banks and story themes can be aligned with curriculum goals. Contact admin for custom word bank creation.',
  },
  {
    q: 'How do live sessions work?',
    a: 'Start a session, share the code with students, and they join from their Academy. You can monitor participation in real-time.',
  },
];
